/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { salesChannelAllowsGuestType, getAccountTypeSelector } from '../../utils';
import { fetchPricingView } from '../../actions/pricingViewActions';

import { RateTable } from '../../components/RateTable';

export function TourRatesContainer() {
    const dispatch = useDispatch();
    const { facilityId, tourId } = useParams();

    const account = useSelector((state) => state?.auth?.account) || {};
    const pricingViewData = useSelector((state) => state.timedEntry.pricingView);
    const facilityData = useSelector((state) => state.timedEntry.facility);
    const tourData = useSelector((state) => state.timedEntry.tours);
    const tourMap = tourData?.tourMap[tourId];

    const { pricesByCategory, isLoading } = pricingViewData;

    const { guest_types: guestTypes, accepts_passes: acceptsPassesFacility } =
        facilityData;

    const { accepts_passes: acceptsPassesTour } = tourMap;

    const filteredGuestTypes = guestTypes.filter((guestType) =>
        salesChannelAllowsGuestType(guestType)
    );

    const accountType = getAccountTypeSelector(account, facilityId);

    const salesCategory = accountType === 'COMM' ? 'ORGANIZATION' : 'INDIVIDUAL';

    // we attempt to get the ORGANIZATION specific fees ...
    let allTourPrices = pricesByCategory?.[salesCategory] || [];

    // ... if they are not found, fallback to individual
    if (isEmpty(allTourPrices)) {
        allTourPrices = pricesByCategory?.INDIVIDUAL || [];
    }

    const [pricing] = allTourPrices.filter((item) => item.tour_id === tourId);

    useEffect(() => {
        if (facilityId) {
            dispatch(fetchPricingView(facilityId));
        }
    }, [dispatch, facilityId]);

    return (
        <RateTable
            isLoading={isLoading}
            tourName={pricing?.tour_name}
            pricingByGuestTypeId={pricing?.guest_type_pricing_by_guest_type_id}
            applicationFee={pricing?.application_fee}
            reservationFee={pricing?.reservation_fee}
            cancellationFee={pricing?.cancellation_fee}
            lateCancellationFee={pricing?.late_cancellation_fee}
            quantityDiscountThreshold={pricing?.quantity_discount_threshold}
            cancellationWindowDescription={pricing?.cancellation_window_description}
            guestTypes={filteredGuestTypes}
            acceptsPasses={acceptsPassesTour ?? acceptsPassesFacility}
        />
    );
}
